import { useState } from 'react';
import { TAG_TYPES, type TagType } from '../../types/tag.js';
import type { TagCandidate } from '../../lib/utils/tag-filter.js';
import { MultiFilterBar } from './MultiFilterBar.js';

interface Props {
  candidates: Record<TagType, TagCandidate[]>;
  value: Record<TagType, string[]>;
  onChange: (type: TagType, next: string[]) => void;
}

/**
 * タグ系フィルタを 1 つの hairline ブロックに集約して表示する。
 * デフォルトは閉じており、ヘッダクリックで type 別 MultiFilterBar 群を展開する。
 * 候補 0 件の type 行は出さない。全 type で候補が 0 件のときはブロック自体非表示。
 */
export function TagFilterGroup({ candidates, value, onChange }: Props) {
  const [open, setOpen] = useState(false);
  const visibleTypes = TAG_TYPES.filter((t) => candidates[t].length > 0);
  if (visibleTypes.length === 0) return null;
  const totalSelected = TAG_TYPES.reduce((n, t) => n + value[t].length, 0);
  return (
    <div className={`tag-filter-block ${open ? 'open' : 'closed'}`}>
      <button
        type="button"
        className={`filter-chip tag-filter-toggle ${totalSelected > 0 ? 'active' : ''}`}
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span aria-hidden className="tag-filter-caret">{open ? '−' : '＋'}</span>
        <span>タグで絞り込み</span>
        {totalSelected > 0 && <span className="chip-count">{totalSelected}</span>}
      </button>
      {open &&
        visibleTypes.map((t) => (
          <MultiFilterBar
            key={t}
            groupLabel={t}
            filters={candidates[t]}
            value={value[t]}
            onChange={(next) => onChange(t, next)}
          />
        ))}
    </div>
  );
}
